import { Typography } from '@mui/material';
import { Box, styled } from '@mui/system';
import { theme } from 'theme';

export const PKDModalWrapper = styled(Box)(({ theme, width }) => ({
  backgroundColor : theme.palette.primary.white,
  maxWidth        : '100%',
  width,
  borderRadius    : '8px',
  overflow        : 'auto',
  position        : 'absolute',
  top             : '50%',
  left            : '50%',
  maxHeight       : '90vh',
  transform       : 'translate(-50%, -50%)',
}));

export const PKDModalHeader = styled(Box)(({ theme }) => ({
  height          : '66px',
  borderBottom    : `1px solid ${theme.palette.primary.gray15}`,
  display         : 'flex',
  alignItems      : 'center',
  justifyContent  : 'center',
  position        : 'sticky',
  top             : 0,
  zIndex          : '100',
  backgroundColor : theme.palette.primary.white,
}));
export const PKDModalContent = styled(Box)(({ theme }) => ({
  padding : '16px',
}));

export const PKDModalClose = styled(Box)(() => ({
  height    : '16px',
  width     : '16px',
  position  : 'absolute',
  top       : '50%',
  transform : 'translate(-50%, -50%)',
  right     : '16px',
  color     : theme.palette.primary.gay6,
  cursor    : 'pointer',
}));

export const PKDModalTitle = styled(Typography)(({ theme }) => ({
  fontFamily    : 'Montserrat',
  fontSize      : '16px',
  fontWeight    : '700',
  lineHeight    : '24px',
  letterSpacing : '0em',
  textAlign     : 'center',
}));
